import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'ca-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  @Input() loading = false;

  constructor () {}

  ngOnInit (): void {}
}
